<script setup lang="ts">
import { ArrowRightIcon, LockKeyholeOpenIcon } from '@lucide/vue';

import { cn } from '@/shared/lib/misc';
import { buttonVariants } from '@/shared/ui/button';
</script>

<template>
  <div
    class="from-primary/5 dark:from-primary/10 border-primary ring-primary/10 relative overflow-hidden rounded-lg border bg-gradient-to-b to-transparent p-4 shadow-sm ring-2"
  >
    <div class="space-y-3">
      <div class="flex items-center gap-2">
        <LockKeyholeOpenIcon class="text-primary size-4.5" />
        <div class="flex-1 space-y-1">
          <h4 class="text-sm leading-tight font-medium">Unlock all features</h4>
        </div>
      </div>
      <p class="text-muted-foreground text-xs leading-relaxed">
        Verify your account to unlock all features and resources.
      </p>

      <RouterLink
        :to="{ name: 'billing' }"
        :class="
          cn(
            buttonVariants({ variant: 'default', size: 'sm' }),
            'flex items-center justify-center gap-2',
          )
        "
      >
        Verify account
        <ArrowRightIcon class="size-3.5" />
      </RouterLink>
    </div>
  </div>
</template>
